import * as actionTypes from "../constants/userContants";

export const userReducers = (currentUser = "", action) => {
  switch (action.type) {
    case actionTypes.FETCHUSER:
      return action.payload;
    case actionTypes.UPDATEUSER:
      return currentUser?._id === action?.payload._id
        ? action?.payload
        : currentUser;
    default:
      return currentUser;
  }
};
